import React, { useEffect, useState } from "react";
import { HOTMART_URL } from "../../lib/constants";
import { ArrowRight } from "lucide-react";

export default function StickyCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 800);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="sticky-cta"
      className={`fixed bottom-0 inset-x-0 z-40 transition-transform duration-300 sm:hidden ${
        visible ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <div className="bg-black/95 backdrop-blur-md border-t border-yellow-400/40 px-4 py-3 flex items-center gap-3">
        <div className="flex-1 min-w-0">
          <div className="text-[10px] uppercase tracking-widest text-zinc-500">Hoje apenas</div>
          <div className="flex items-baseline gap-2">
            <span className="font-display text-2xl text-white">€147</span>
            <span className="text-xs text-zinc-500 line-through">279€</span>
          </div>
        </div>
        <a
          href={HOTMART_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="sticky-cta-button"
          className="inline-flex items-center gap-2 bg-yellow-400 hover:bg-yellow-300 text-black font-display uppercase tracking-wide text-sm px-5 py-3"
        >
          Quero Cartão SIGO
          <ArrowRight className="w-4 h-4" />
        </a>
      </div>
    </div>
  );
}
